<script lang="ts">
  import type { ArtAssetFormat } from '@do/models';

  import { Icon } from '@shared/ui/icon';

  import type { ArtAsset } from '@entities/art-asset';

  import { ArtworkDoModal } from '@features/artwork/artwork-do-modal';

  import FormatLabel from './format-label.svelte';

  export let digitalOriginal: ArtAsset['digital_original'];
  export let format: ArtAssetFormat | undefined;

  let isDoModalOpen = false;
</script>

<div class="mb-3 flex items-center gap-4">
  <ArtworkDoModal digitalOriginalData="{digitalOriginal}" bind:isShowModal="{isDoModalOpen}" />
  {#if format}
    <FormatLabel {format} />
  {/if}
</div>
<div class="dark:text-dark-800 mb-5 flex max-w-[416px] gap-2 text-sm lg:max-w-full">
  <div>
    <Icon name="info" width="{18}" height="{18}" />
  </div>

  {#if digitalOriginal}
    <div>
      This is a <strong>Digital Original</strong> of the artwork, digitized
      <br class="hidden xl:block" />
      using
      <button on:click="{() => (isDoModalOpen = true)}"><strong class="underline">DLCT</strong></button>
      technology, and <strong>exists as a unique exemplar.</strong>
      <br />
      Each Digital Original is <strong>verified and secured </strong> through blockchain technology, providing
      <strong>full rights to exclusive digital ownership.</strong>
    </div>
  {:else}
    This is a unique piece of art in the digital format, presented directly by the artist or their representative,
    ensuring its authenticity and exceptional quality.
  {/if}
</div>
